import { styled } from '@mui/material/styles';
import { IProps } from './model';

export const ButtonLoginContainer = styled('div')<IProps>`
  min-width: 120px;
  @media (max-width: 1199px) {
    display: ${({ showMobile }) => (showMobile ? 'contents' : 'none')};
  }
`;
